import React from "react";
import { Typography } from "antd";
import { useIntl } from "react-intl";
import Item from "./Item";
import moment from "moment";
const { Title } = Typography;

const AdditionalDetails = (props) => {
  const { order } = props;
  const intl = useIntl();

  return (
    <div style={{ width: "100%" }}>
      <div className="section" style={{ width: "100%" }}>
        <div>
          <Title level={5}>
            {intl.formatMessage({
              id: "app.order_print.moreDetails",
            })}
          </Title>
          <div className="rowContainer">
            <Item
              name="order_service_type_id"
              content={order["order_service_type.name"]}
              line_type="vertical"
            />
            <div className="horizontal_spacer" />
            <Item
              name="order_received_date"
              content={
                order.order_received_date &&
                moment(order.order_received_date).format("DD/MM/YYYY")
              }
              line_type="vertical"
            />
            <div className="horizontal_spacer" />
            <Item
              name="reference_number"
              content={order.reference_number}
              line_type="vertical"
            />
            <div className="horizontal_spacer" />
            <Item
              name="commitment_number"
              content={order.commitment_number}
              line_type="vertical"
            />
          </div>
        </div>

        <div className="verticalSeperator" />
        <div>
          <div className="rowContainer">
            <Item
              name="benefit_level"
              content={order.benefit_level}
              line_type="vertical"
            />
            <div className="horizontal_spacer" />
            <Item
              name="adl_score"
              content={order.adl_score}
              line_type="vertical"
            />
            <div className="horizontal_spacer" />
            <Item
              name="order_received"
              content={order.order_received ? "כן" : "לא"}
              line_type="vertical"
            />
            <div className="horizontal_spacer" />
            <Item
              name="order_close_reason.name"
              content={order["order_close_reason.name"]}
              line_type="vertical"
            />
          </div>
        </div>

        <div className="verticalSeperator" />
        <div>
          <Item name="remarks" content={order.remarks} line_type="vertical" />
        </div>
      </div>
    </div>
  );
};

export default AdditionalDetails;
